import { Box, Typography, styled } from "@mui/material";

export const PanelContainer = styled(Box, {
  label: "BackRightPanelContainer",
})(() => ({
  width: 368,
  flexShrink: 0,
  height: 569,
  display: "flex",
  flexDirection: "column",
  gap: 16,
  overflowY: "auto",
  backgroundColor: "rgba(145, 158, 171, 0.2)",
  backdropFilter: "blur(30px)",
  WebkitBackdropFilter: "blur(30px)",
  borderRadius: 16,
  padding: "20px 24px",
  "&::-webkit-scrollbar": { width: "6px" },
  "&::-webkit-scrollbar-track": { background: "transparent" },
  "&::-webkit-scrollbar-thumb": {
    background: "rgba(145, 158, 171, 0.3)",
    borderRadius: "3px",
  },
}));

export const SectionHeader = styled(Typography, {
  label: "BackRightSectionHeader",
})(() => ({
  fontFamily: "Proxima Nova, sans-serif",
  fontWeight: 700,
  fontSize: "18px",
  lineHeight: "28px",
  color: "#ffffff",
  textAlign: "center",
  width: "100%",
}));

export const SubSectionHeader = styled(Typography, {
  label: "BackRightSubSectionHeader",
})(() => ({
  fontFamily: "Proxima Nova, sans-serif",
  fontWeight: 700,
  fontSize: "11px",
  lineHeight: "16px",
  color: "rgba(255, 255, 255, 0.64)",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
}));

export const ColumnHeader = styled(Typography, {
  label: "BackRightColumnHeader",
})(() => ({
  fontFamily: "Proxima Nova, sans-serif",
  fontWeight: 600,
  fontSize: "13px",
  lineHeight: "20px",
  color: "rgba(255, 255, 255, 0.64)",
}));

export const SalaryAmount = styled(Typography, {
  label: "BackRightSalaryAmount",
})(() => ({
  fontFamily: "Proxima Nova, sans-serif",
  fontWeight: 700,
  fontSize: "16px",
  lineHeight: "24px",
  color: "#dfe3e8",
}));

export const ItemRow = styled(Box, { label: "BackRightItemRow" })(() => ({
  display: "flex",
  alignItems: "center",
  gap: 8,
  paddingTop: 4,
  paddingBottom: 4,
}));

export const ItemIcon = styled(Box, { label: "BackRightItemIcon" })(() => ({
  width: 28,
  height: 28,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
}));

export const ItemName = styled(Typography, {
  label: "BackRightItemName",
})(() => ({
  fontFamily: "Proxima Nova, sans-serif",
  fontWeight: 500,
  fontSize: "13px",
  lineHeight: "20px",
  color: "#ffffff",
}));
